import * as React from 'react'

import { FormEditor } from '../editor/markup-editor'
import { Popover } from 'antd'
// import { Scaffold } from '../editor/scaffold';
import { Formml } from 'formml'
const { Compiler } = Formml
import Chip from '@mui/material/Chip'

import Grid from '@mui/material/Grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '@mui/material/Button'
import Switch from '@mui/material/Switch'

type ReactFormBuilderProps = {
  formPath: string;
  initialValue?: string
  onFormChanged: (form) => void
}

enum QuickAdd {
  TextInput = 1,
  SelectInput,
  CustomSubmit
}

export class ReactFormBuilder extends React.Component<ReactFormBuilderProps> {
  editor = React.createRef<HTMLTextAreaElement>()
  preview = React.createRef<HTMLDivElement>()
  formEditor: any

  componentDidMount(): any {
    const grammar = new Compiler()
    const key = this.props.formPath.split('/').slice(-1)[0]
    this.formEditor = new FormEditor(grammar, this.editor.current, this.preview.current, this.props.initialValue, key)
    // // Update UI Display
    this.formEditor.onFormChanged.on(this.props.onFormChanged)
  }

  handleSwitchChange(checkValue) {
    const formTestMode = this.preview.current.querySelectorAll('form-preview')[0]
    const previewForm = formTestMode.shadowRoot.querySelectorAll('formtopia-form')[0]
    if (previewForm) {
      previewForm.setAttribute('testmode', checkValue.target.checked.toString())
    }
  }

  onClickQuickAddButton = (e, type) => {
    e.preventDefault()

    let code = `${this.formEditor.code}\n`
    switch (type) {
      case QuickAdd.TextInput:
        code += 'field_name:text<Label|Placeholder>'
        break;
      case QuickAdd.SelectInput:
        code += 'field_name:select<Label>\n- option_1<Label 1>\n- option_2<Label 2>'
        break;
      case QuickAdd.CustomSubmit:
        code += ':submit<Custom Submit>'
        break;
      default:
        break;
    }

    this.formEditor.code = code
    this.formEditor._ed.setValue(this.formEditor.code)
  }

  insertFields = [
    {
      label: 'Text Input',
      type: QuickAdd.TextInput
    },
    {
      label: 'Select Input',
      type: QuickAdd.SelectInput
    },
    {
      label: 'Custom Submit',
      type: QuickAdd.CustomSubmit
    }
  ]

  render(): React.ReactNode {
    const lightGrey = '#f4f4f4'
    const black = '#272822'

    return (
      <Grid container id="edit_container">
        <Grid item xs={6} style={{ height: '60vh', backgroundColor: black, border: '1px solid grey', borderRadius: '5px 0px 0px 5px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className="editor-header" style={{ minHeight: 75, padding: 20, color: lightGrey }}>
              <h3 style={{ color: lightGrey }}>Form Editor</h3>
            </div>
            <div style={{ padding: '0px 20px', color: lightGrey, marginBottom: 30 }}>
              <div className="editor-inserts" style={{ border: '1px solid grey', borderRadius: '5px', padding: 10 }}>
                <h4 style={{ color: lightGrey }}>INSERT FIELDS</h4>
                <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 10 }}>
                  {this.insertFields.map((field, i) => <Chip style={{ marginRight: 10, marginTop: 10 }} size="large" label={field.label} color="secondary" variant="outlined" onClick={(event) => this.onClickQuickAddButton(event, field.type)} />)}
                </div>
              </div>
            </div>
            <textarea ref={this.editor} />
          </div>
        </Grid>
        <Grid item xs={6} style={{ height: '60vh', backgroundColor: black, border: '1px solid grey', borderRadius: '0px 5px 5px 0px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ minHeight: 75, padding: 20, color: lightGrey, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ color: lightGrey }}>Form Preview</h3>

              <FormControlLabel
                control={
                  <Popover overlayStyle={{ maxWidth: '30%' }} content={"When Test Mode is OFF, clicking Submit will save a new form Entry and your Workflows will trigger.  When Test Mode is ON, you can still click the Submit button to test form validation, but entries will not be saved, and none of your Workflows will trigger."} title="Test Mode">
                    <Switch defaultChecked
                      classes={{
                        root: 'testModeSwitch',
                        disabled: 'testModeSwitch'
                      }}
                      onChange={(checkValue) => this.handleSwitchChange(checkValue)}
                    />
                  </Popover>
                }
                label="Test Mode"
              />
            </div>
            <div style={{ margin: '0px 20px', marginBottom: 20, borderRadius: 5, padding: '15px 20px', overflow: 'scroll', backgroundColor: '#f4f4f4', height: '100%', }}>
              <div style={{ width: '100%' }} ref={this.preview}></div>
            </div>
          </div>
        </Grid>
      </Grid >
    )
  }
}
